import React from 'react';

const TrackNext = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"  
            x="0px" 
            y="0px" 
            viewBox="0 0 320 320" 
            space="preserve">

            <path 
                fill="currentColor"
                d="M288,0c-8.832,0-16,7.168-16,16v116.64L39.84,2.048c-4.896-2.752-11.008-2.72-15.904,0.128S16,10.304,16,16v288  c0,5.696,3.04,10.944,7.936,13.824C26.4,319.264,29.216,320,32,320c2.72,0,5.408-0.672,7.84-2.048L272,187.36V304  c0,8.832,7.168,16,16,16s16-7.168,16-16V16C304,7.168,296.832,0,288,0z"/>

        </svg>
    );
}

export default TrackNext;
